import { Box, IconButton, Typography, useTheme } from '@mui/material'

import { useCopy } from 'src/hooks'
import { LinkItem } from './link-item.component'
import { IMAGE_LARGE_WIDTH, IMAGE_MEDIUM_WIDTH, IMAGE_SMALL_WIDTH } from 'src/constants'
import CopyIcon from '@mui/icons-material/ContentCopy'

interface IProps {
  id: string
  link: string
  small: string | null
  medium: string | null
  large: string | null
  width: number | null
  height: number | null
  size?: number | null
  size_large?: number | null
  size_medium?: number | null
  size_small?: number | null
}

export const LinkCell = ({
  id,
  link,
  small,
  medium,
  large,
  width,
  height,
  size,
  size_large,
  size_medium,
  size_small,
}: IProps) => {
  const theme = useTheme()
  const copy = useCopy(id)

  const dimensions = width && height ? `${width}x${height}` : null
  const multiplier = height && width ? height / width : 1

  return (
    <ul>
      <LinkItem link={link} title={'Original'} dimensions={dimensions} size={size} />
      {large && (
        <LinkItem
          link={large}
          title={'Large'}
          dimensions={`${IMAGE_LARGE_WIDTH}x${Math.round(multiplier * IMAGE_LARGE_WIDTH)}`}
          size={size_large}
        />
      )}
      {medium && (
        <LinkItem
          link={medium}
          title={'Medium'}
          dimensions={`${IMAGE_MEDIUM_WIDTH}x${Math.round(multiplier * IMAGE_MEDIUM_WIDTH)}`}
          size={size_medium}
        />
      )}
      {small && (
        <LinkItem
          link={small}
          title={'Small'}
          dimensions={`${IMAGE_SMALL_WIDTH}x${Math.round(multiplier * IMAGE_SMALL_WIDTH)}`}
          size={size_small}
        />
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography sx={{ fontSize: '14px', width: '60px' }}>UUID</Typography>
        <IconButton size="small" onClick={copy}>
          <CopyIcon
            sx={{
              color: theme.palette.custom.grey2,
              width: 20,
              height: 'auto',
            }}
          />
        </IconButton>
      </Box>
    </ul>
  )
}
